import { z } from 'zod';
import { yesNoRequired } from '@utils/form-schema';

const hasText = (value: string) => value.trim() !== '';

export const historyMiscSchema = z
    .object({
        hasAllergies: yesNoRequired,
        allergies: z.array(z.object({ name: z.string() })),
        hasHadSurgeries: yesNoRequired,
        surgeries: z.array(z.object({ name: z.string(), when: z.string() })),
        takesMedication: yesNoRequired,
        medicines: z.array(
            z.object({ name: z.string(), dose: z.string(), frequency: z.string() }),
        ),
    })
    .superRefine((data, ctx) => {
        const required = (path: 'allergies' | 'surgeries' | 'medicines') =>
            ctx.addIssue({ code: 'custom', path: [path], message: 'Required' });

        if (data.hasAllergies === '1' && !data.allergies.some((x) => hasText(x.name))) {
            required('allergies');
        }

        if (data.hasHadSurgeries === '1') {
            const named = data.surgeries.filter((x) => hasText(x.name));

            if (named.length === 0 || named.some((x) => !hasText(x.when))) {
                required('surgeries');
            }
        }

        if (data.takesMedication === '1') {
            const named = data.medicines.filter((x) => hasText(x.name));

            if (named.length === 0 || named.some((x) => !hasText(x.dose) || !hasText(x.frequency))) {
                required('medicines');
            }
        }
    });
